<script>
import { mapGetters, mapActions, mapState } from 'vuex';
import store from '../../../store';
import SkiPersonCategory from '../../../components/ski/school/SkiSchoolPersonCategory';
import i18n from '../../../i18n';

export default {
  name: 'SkiSchoolPersonCategories',
  components: {
    SkiPersonCategory,
  },
  computed: {
    ...mapGetters({
      personCategories: 'skischool/getPersonCategories',
    }),
    ...mapState({
      season: state => state.skischool.season,
      personCategoriesLoading: state => state.skischool.season.personCategories.itemsLoading,
      personCategoriesError: state => state.skischool.season.personCategories.itemsError,
      personCategorySaveLoading: state => state.skischool.season.personCategories.saveLoading,
      personCategorySaveError: state => state.skischool.season.personCategories.saveError,
    }),
    isNewPersonCategoryActive() {
      return this.personCategories.some(personCategory => personCategory.id === undefined);
    },
    errorOccurred() {
      return this.personCategoriesError || this.personCategorySaveError;
    },
  },
  methods: {
    ...mapActions({
      loadPersonCategories: 'skischool/personCategoriesByIdLoad',
      addNewPersonCategory: 'skischool/personCategoryAddNew',
      createPersonCategory: 'skischool/personCategoryCreate',
      savePersonCategory: 'skischool/personCategorySave',
      removePersonCategory: 'skischool/personCategoryRemove',
      setPersonCategory: 'skischool/setPersonCategory',
    }),
    createOrUpdate(personCategory) {
      if (personCategory.id) {
        this.savePersonCategory(personCategory);
      } else {
        this.createPersonCategory(personCategory);
      }
    },
    remove(personCategoryId) {
      // eslint-disable-next-line no-alert
      if (!personCategoryId || confirm(i18n.t('ski.skiPersonCategory.removeAreYouSure'))) {
        this.removePersonCategory(personCategoryId);
      }
    },
    onPersonCategoryChange(payload) {
      this.setPersonCategory(payload);
    },
  },
  beforeRouteEnter(to, from, next) {
    if (to.params.seasonId) {
      store.dispatch('skischool/personCategoriesByIdLoad', to.params.seasonId)
        .finally(() => {
          next();
        });
    }
  },
};
</script>
<template>
  <v-container class="pa-0">
    <div>
      <h2 class="d-inline-block">
        {{ $t('ski.skiPersonCategories.title') }}
        ({{ Object.keys(this.personCategories).length }})
      </h2>
      <v-btn
        @click="this.addNewPersonCategory"
        :disabled="isNewPersonCategoryActive
          || this.personCategoriesLoading
          || this.personCategorySaveLoading
        "
        class="mb-2"
        color="success"
        outline
      >
        {{ $t('ski.skiPersonCategories.new') }}
      </v-btn>
      <v-btn
        @click="loadPersonCategories(season.id)"
        :loading="personCategoriesLoading"
        icon
      >
        <v-icon>cached</v-icon>
      </v-btn>
    </div>
    <div class="text-center">
      <v-progress-linear
        v-if="this.personCategoriesLoading || this.personCategorySaveLoading"
        :indeterminate="true"
      />
    </div>
    <v-alert
      :value="this.errorOccurred"
      color="error"
      icon="warning"
      outline
    >
      <span v-html="errorOccurred"></span>
    </v-alert>
    <v-layout v-if="personCategories.length" wrap>
      <v-flex sm2 xs12 offset-sm1>
        <p class="font-weight-bold pl-2 pt-2">{{ $t('ski.skiPersonCategory.nameSupplier') }}</p>
      </v-flex>
      <v-flex sm2 xs12>
        <p class="font-weight-bold pl-2 pt-2">{{ $t('ski.skiPersonCategory.nameWebsite') }}</p>
      </v-flex>
      <v-flex sm1 xs12>
        <p class="font-weight-bold pl-2 pt-2">{{ $t('ski.skiPersonCategory.ageFrom') }}</p>
      </v-flex>
      <v-flex sm1 xs12>
        <p class="font-weight-bold pl-2 pt-2">{{ $t('ski.skiPersonCategory.ageTo') }}</p>
      </v-flex>
      <v-flex sm2 xs12>
      </v-flex>
    </v-layout>
    <v-layout
      v-for="(personCategory) in personCategories"
      :key="'ski-person-category-' + personCategory.id"
      :loading="personCategoriesLoading"
      xs12
    >
      <ski-person-category
        @onPersonCategoryChange="onPersonCategoryChange"
        @createOrUpdate="createOrUpdate"
        @remove="remove"
        :category="personCategory"
        :save-loading="personCategorySaveLoading"
      />
    </v-layout>
  </v-container>
</template>



// WEBPACK FOOTER //
// src/pages/ski/school/SkiSchoolSeasonPersonCategories.vue